export default __webpack_public_path__ + "140bc40de877de3b43152a58760265e2.webp";